import { Checkbox, CheckboxField } from '@/components/ui/catalyst/checkbox';
import { Description, Label } from '@/components/ui/catalyst/fieldset';
import { SaveMode } from '@/types/provider-destinations';

interface SaveBehaviorToggleProps {
  value: SaveMode;
  onChange: (value: SaveMode) => void;
}

export const SaveBehaviorToggle = ({
  value,
  onChange,
}: SaveBehaviorToggleProps) => {
  const isDefaultForFutureRequests = value === SaveMode.SAVE_FOR_FUTURE;

  return (
    <CheckboxField>
      <Checkbox
        checked={isDefaultForFutureRequests}
        onChange={(checked: boolean) =>
          onChange(checked ? SaveMode.SAVE_FOR_FUTURE : SaveMode.USE_ONCE)
        }
        color="blue"
      />
      <Label>Set as default for future requests</Label>
      <Description>
        If off, this destination is used only for this request.
      </Description>
    </CheckboxField>
  );
};
